module.exports = __webpack_public_path__ + "img/security-and-navigation-right-success.4f65ac0e.svg";